var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSy3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.5714 0H5.42857C2.44286 0 0 2.44286 0 5.42857V70.5714C0 73.5571 2.44286 76 5.42857 76H46.1429V70.5714C46.1429 62.9714 52.1143 57 59.7143 57V51.5714C49.1286 51.5714 40.7143 59.9857 40.7143 70.5714H32.5714V59.7143H27.1429V70.5714H5.42857V5.42857H27.1429V43.4286H32.5714V29.8571H43.4286V24.4286H32.5714V5.42857H70.5714V24.4286H59.7143V29.8571H70.5714V70.5714H59.7143V76H70.5714C73.5571 76 76 73.5571 76 70.5714V5.42857C76 2.44286 73.5571 0 70.5714 0Z",
    fill: "#C49A6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSy3);
export default __webpack_public_path__ + "static/media/SY3.dc002005e6cd7c36b0217de9281af44d.svg";
export { ForwardRef as ReactComponent };